import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { CreateStandardOrderPaymentLinkPayload } from "shared/api/middleware-api-client";

// Function to create a standard order payment link
const createStandardOrderPaymentLink = async (
  orderId: string,
  payload: CreateStandardOrderPaymentLinkPayload,
) => {
  const res = await api().gersCreateStandardProductOrderPaymentLink(
    orderId,
    payload,
  );

  return res.data;
};

// Custom hook to handle the creation of a payment link for a standard product
export const useStandardProductCreatePaymentLink = () => {
  const {
    mutate: createStandardProductOrderPaymentLink,
    isLoading: isCreateStandardOrderPaymentLinkLoading,
  } = useMutation(
    ({
      orderId,
      payload,
    }: {
      orderId: string;
      payload: CreateStandardOrderPaymentLinkPayload;
    }) => createStandardOrderPaymentLink(orderId, payload),
    {
      // Redirect to the payment URL on successful creation of the payment link
      onSuccess: (data) => {
        window.location.href = data.paymentUrl;
      },
      // Show an error toast if there is an error during the creation of the payment link
      onError: () => {
        toast.error("Er is iets fout gegaan in het betaalproces.");
      },
    },
  );

  // Return the mutation function and loading state
  return {
    createStandardProductOrderPaymentLink,
    isCreateStandardOrderPaymentLinkLoading,
  };
};
